import React, { useEffect, useState, useRef} from 'react';
import { isMobile } from 'react-device-detect';
import { debounce } from 'lodash';
import useBlockExistence from './useBlockExistence';
const AnchorsTabs = (props) => {
  const anchorElements = props.iContent.anchorElements.value;
  const [activeBlock, setActiveBlock] = useState(anchorElements[0].linked_block);
  const tabsWrapperRef = useRef(null);
  const headerHeightRef = useRef(0);
  const existingBlocks = anchorElements;
  const currentClass='anchors-tabs-wrapper';
  const scrollSpacerId = 'anchors-scroll-spacer';
  const headerRef = useRef(null);


  const getTargetElement = (blockId) => {
    var targetElement = document.getElementById(blockId);
    if(targetElement?.tagName === 'SPAN') {
      targetElement = targetElement.nextElementSibling;
    }
    return targetElement;
  }

  const ensureScrollRoom = (targetTop) => {
    const docEl = document.documentElement;
    const maxScrollTop = Math.max(0, docEl.scrollHeight - window.innerHeight);
    const requiredExtra = Math.max(0, targetTop - maxScrollTop);

    const root = document.getElementById('epi-page-container') || document.body;
    if (!root) return;

    let spacer = document.getElementById(scrollSpacerId);
    if (!spacer) {
      spacer = document.createElement('div');
      spacer.id = scrollSpacerId;
      spacer.setAttribute('aria-hidden', 'true');
      spacer.style.width = '1px';
      spacer.style.pointerEvents = 'none';
      root.appendChild(spacer);
    }

    spacer.style.height = requiredExtra > 0 ? `${requiredExtra + 16}px` : '0px';
  };


 


  const getElementsHeight = (elements , currentHeight) => {
       for (const selector of elements) {
      const headerElement = document.querySelector(selector);
      if (headerElement) {
        currentHeight = currentHeight +  headerElement.offsetHeight || headerElement.getBoundingClientRect().height;
      }
    }
    return currentHeight;
  };



  const scrollToBlock = (linkedBlock) => {
    const blockId = `block-${linkedBlock}`;
    var targetElement = getTargetElement(blockId);
    if(targetElement?.tagName === 'SPAN') {
      targetElement = targetElement.nextElementSibling;
    }
    if (targetElement) {
      const headerHeight = calculateHeaderHeight();

      const style = window.getComputedStyle(targetElement);
      const marginTop = parseFloat(style.marginTop) || 0;
      const elementPosition =
        targetElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerHeight - marginTop;
      ensureScrollRoom(offsetPosition);
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

    }
  };


  const handleClick = (e, linkedBlock) => {
    e.preventDefault();
    scrollToBlock(linkedBlock);
  };
  const calculateHeaderHeight = () => {

    const tabsWrapper = tabsWrapperRef.current;
    const stickyParent = tabsWrapper?.offsetParent;

    const HeaderCalCulateTop = [
      '.header-top-menu',
      '.header-bottom-menu',
    ];
  
    const HeaderSelectors = [...HeaderCalCulateTop, `.${currentClass}`];

    const elementsToIgnoreForStickyCalculation = [
      'header-container',
      'closing'
    ];

    let stickyElementsInfo = [];
    const routPageContainer = document.getElementById('epi-page-container');
    if(routPageContainer){
      const allChildren = Array.from(routPageContainer.querySelectorAll("*"));
      const currentIndex = allChildren.indexOf(stickyParent);
      const childrenBefore = currentIndex !== -1 ? allChildren.slice(0, currentIndex) : allChildren; 
      stickyElementsInfo = Array.from(childrenBefore)
        .filter(el => {
          const style = window.getComputedStyle(el);
          return (style.position === "sticky" || style.position === "fixed") && 
                 !elementsToIgnoreForStickyCalculation.some(cls => el.classList.contains(cls)) &&
                 !el.querySelector(`div.${currentClass}`);
        })
        .map(el => ({ height: el.offsetHeight }));
    }

    const baseStickyHeight = stickyElementsInfo.reduce((acc, curr) => acc + curr.height, 0);
    const topPosition = getElementsHeight(HeaderCalCulateTop, baseStickyHeight);
    const totalHeight = getElementsHeight(HeaderSelectors, baseStickyHeight);

    
    if (stickyParent) {
      stickyParent.style.top = topPosition + "px";
    }

    return totalHeight;
  };

  useEffect(() => {
    const root = document.getElementById('epi-page-container');
    if (!root) return;
  
    const debouncedCalculate = debounce(() => {
      headerHeightRef.current = calculateHeaderHeight();
    }, 10);
  
    const resizeObserver = new ResizeObserver(debouncedCalculate);
    resizeObserver.observe(root);
    window.addEventListener('resize', debouncedCalculate);
    debouncedCalculate(); 

    return () => {
      debouncedCalculate.cancel();
      resizeObserver.disconnect();
      window.removeEventListener('resize', debouncedCalculate);
    };
  }, []);
  
  const handleScroll = () => {
    // Use the SAVED height from the ref instead of recalculating
    const headerHeight = headerHeightRef.current;
    let closestBlock = null;
    let closestDistance = Infinity;

    anchorElements.forEach((anchor) => {
      const blockId = `block-${anchor.linked_block}`;
      const el = getTargetElement(blockId);
      if (el) {
        const rect = el.getBoundingClientRect();
        const style = window.getComputedStyle(el);
        const marginTop = parseFloat(style.marginTop) || 0;
        const distance = Math.abs(rect.top - marginTop - headerHeight);
        
        if (distance < closestDistance) {
          closestDistance = distance;
          closestBlock = anchor.linked_block;
        }
      }
    });

    if (closestBlock !== null && closestBlock !== activeBlock) {
      setActiveBlock(closestBlock);
    }
  };

  //   const headerHeight = getHeaderHeight();
  //   let closestBlock = null;
  //   let closestDistance = Infinity;

  //   anchorElements.forEach((anchor) => {
  //     const blockId = `block-${anchor.linked_block}`;
  //     const el = getTargetElement(blockId);
  //     if (el) {
  //       const rect = el.getBoundingClientRect();
  //       const style = window.getComputedStyle(el);
  //       const marginTop = parseFloat(style.marginTop) || 0;
        
  //       // Calculate distance from the current viewport top (adjusted for header)
  //       const distance = Math.abs(rect.top - marginTop - headerHeight);
        
  //       if (distance < closestDistance) {
  //         closestDistance = distance;
  //         closestBlock = anchor.linked_block;
  //       }
  //     }
  //   });

  //   // CRITICAL: Only update state if the block actually changed
  //   // Move this OUTSIDE the forEach loop to prevent multiple re-renders
  //   if (closestBlock !== null && closestBlock !== activeBlock) {
  //     setActiveBlock(closestBlock);
  //   }
  // };

  useEffect(() => {
    // Throttle scroll events using requestAnimationFrame for smoother performance
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    return () => window.removeEventListener('scroll', onScroll);
  }, [anchorElements, activeBlock]);

  useEffect(() => {
    return () => {
      const spacer = document.getElementById(scrollSpacerId);
      if (spacer && spacer.parentNode) spacer.parentNode.removeChild(spacer);
    };
  }, []);

  // Ensure the active tab is visible in the horizontal scroll (mobile)
  useEffect(() => {
    if (!tabsWrapperRef.current || activeBlock === null) return;

    const activeTab = tabsWrapperRef.current.querySelector(
      `.anchors-tabs a[data-linked-block="${activeBlock}"]`
    );

    if (activeTab && typeof activeTab.scrollIntoView === 'function') {
      activeTab.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  }, [activeBlock]);


  return (
    <div className={currentClass} ref={tabsWrapperRef}>
      <div className="anchors-tabs">
        {anchorElements.map((anchor, idx) => (
          ( <a
            key={idx}
            data-linked-block={anchor.linked_block}
            className={activeBlock === anchor.linked_block ? 'active' : ''}
            onClick={(e) => {
              scrollToBlock(anchor.linked_block);
            }}
          >
            {anchor.text}
          </a>)
        ))}
      </div>
    </div>
  );
};

export default AnchorsTabs;
